import React, { Component } from 'react';
import Grid from 'screens/components/basic/Grid';
import { connect } from 'react-redux';
import { Pagination } from 'react-bootstrap';
import { bulkTransferEditCrumb, bulkTransferViewCrumb } from 'utils/breadcrumbInfo';
import { getBulkTransfersById, getProductQuantity, getPurchaseOrderForBulkTransfer, sendBulkTransfer, getProductsAutocompleteFromWarehouse, getCategories, getProductsGroupedFromWarehouse } from 'actions/EntityActions';
import { getCsvReport } from 'actions/ReportsAction';
import { formError, formInput, clearFormInput } from 'actions/FormActions';
import { showError } from 'actions/CommonActions';
import * as types from 'constants/actionTypes';
import LOOKUP from 'constants/lookup';
import BarcodeReader from 'library/readBarcode';
import { getDollarFormat } from 'utils/helpers';
import TextField from '@mui/material/TextField';
// Basic Components
import AutoCompleteBulkTransfer from 'screens/components/basic/AutoCompleteBulkTransfer';
import Button from 'screens/components/basic/Button';
import SelectInputPackageReference from 'screens/components/basic/SelectInputPackageReference';
import CardSimple from 'screens/components/basic/CardSimple';
// Advanced Components
import GenericTable from 'screens/components/advanced/GenericTable';
import DialogInput from 'screens/components/advanced/DialogInput';

import SearchPOFilterBulkTrasfer from './searchPOFilterBulkTrasfer';
import ExcelUploadBulkTransfer from './excelUploadBulkTransfer';
import WithRouter from 'custom/withRouter'

import ProductCategoriesListBulkTrasfer from './ProductCategoriesListBulkTrasfer';
import DialogHeaderWithClose from 'screens/components/basic/DialogHeaderWithClose';
import PageHeaderWithButton from 'screens/components/basic/PageHeaderWithButton';

class bulkTransferEdit extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            bulkTransferId: 0,
            bulkTransfer: "",
            productsWarehouses: "",
            productsTransfer: [],
            showDialogPO: false,
            activePage: 1
        };
        this.getBulkTransfersById = this.getBulkTransfersById.bind(this);
        this.addProductToTransfer = this.addProductToTransfer.bind(this);
        this.mapProductTransfer = this.mapProductTransfer.bind(this);
        this.addProductFromBulkTransfer = this.addProductFromBulkTransfer.bind(this)
        this.selectPackageReference = this.selectPackageReference.bind(this);
        this.selectQty = this.selectQty.bind(this);
        this.getStatus = this.getStatus.bind(this);
        this.getPurchaseOrders = this.getPurchaseOrders.bind(this);
        this.barcodeReader = new BarcodeReader();
    }

    componentWillMount() {
        this.getBulkTransfersById(this.props.params.id)
    }

    componentDidMount() {
        window.addEventListener("keypress", this.barcodeListener);
    }

    componentWillUnmount() {
        window.removeEventListener("keypress", this.barcodeListener);
        this.props.clearFormInput("bulkTransferBranchFrom");
        this.props.clearFormInput("bulkTransferBranchTo");
        this.props.clearFormInput("bulkTransferWarehouseTo");
        this.props.clearFormInput("bulkTransferWarehouseFrom");
        this.props.clearFormInput("bulkTransferTitle");

        this.state.productsTransfer && this.state.productsTransfer.map((item) => {
            this.props.clearFormInput(`${item.productId}PackageReference`);
            this.props.clearFormInput(`${item.productId}PackageReferenceText`);
        })
        // this.props.clearFormInput("product");
        this.props.clearFormInput("bulkTransferPoFilter")
        window.removeEventListener("keypress", this.barcodeListener);
    }

    barcodeListener = () => {
        if (document.activeElement.tagName != "INPUT") {
            this.barcodeReader.listening(this.getProductByBarcode);
        }
    }

    getProductByBarcode = (barcode) => {
        const model = {
            WarehouseId: this.state.bulkTransfer ? this.state.bulkTransfer.fromWarehouseId : 0,
            Barcode: barcode
        }
        this.props.getProductsAutocompleteFromWarehouse(model);
    }

    componentWillReceiveProps(newProps) {
        if (newProps.productsWarehouses != this.props.productsWarehouses && newProps.productsWarehouses != undefined) {
            this.setState({ ...this.state, productsWarehouses: newProps.productsWarehouses.list });
        }

        if (this.state.bulkTransferId != newProps.params.id) {
            this.setState({ ...this.state, bulkTransferId: newProps.params.id });
        }

        if (newProps.bulkTransfer && newProps.bulkTransfer != this.props.bulkTransfer) {
            this.addProductFromBulkTransfer(newProps.bulkTransfer);
        }

        if (newProps.POSelected && this.props.POSelected != newProps.POSelected) {
            if (this.state.showDialogPO) {
                let selectedPO = newProps.POSelected[0] == undefined ? this.props.POSelected : newProps.POSelected[0];
                let POSelected = newProps.purchaseOrders[selectedPO];
                this.setState({ ...this.state, selectedPOOpen: true, dialogPOTitle: "PO #" + POSelected.id, selectedPO: POSelected });
            }
        }

        if (newProps.bulkTransferSuccess && this.props.bulkTransferSuccess != newProps.bulkTransferSuccess) {
            if (newProps.bulkTransferSuccess) {
                this.props.showBulkTransferUpdateSnackbar("Bulk Transfer updated");
            }
            else {
                this.props.showBulkTransferUpdateSnackbar("Something was wrong, please try again.");
            }
        }

        if (newProps.productQuantity && this.props.productQuantity != newProps.productQuantity) {
            if (newProps.productQuantity.quantity == 0) {
                const tempList = this.state.productsTransfer.filter(x => !(x.productId == newProps.productQuantity.productId && x.PackageReference == newProps.productQuantity.packageReference));
                this.setState({ ...this.state, productsTransfer: tempList })
                this.props.showBulkTransferUpdateSnackbar("Product out of stock.");
            }
            else {
                const tempProduct = this.state.productsTransfer.filter(x => x.productId == newProps.productQuantity.productId && x.PackageReference == newProps.productQuantity.packageReference);
                const tempList = this.state.productsTransfer.filter(x => !(x.productId == newProps.productQuantity.productId && x.PackageReference == newProps.productQuantity.packageReference));
                let product = tempProduct.map(item => {
                    return ({
                        productId: item.productId,
                        packageReferenceSelected: item.packageReferenceSelected || "",
                        SKU: item.SKU,
                        QtyToTransfer: item.QtyToTransfer,
                        ProductName: item.ProductName,
                        PackageReference: item.PackageReference || "No Lot Number",
                        CurrentQty: newProps.productQuantity.quantity
                    })
                }
                );

                if (product.length > 0)
                {
                    product = [product[0]];
                }
                // allows multiple of the same product only if the package reference is different
                const newProductsTransfer = [...tempList, ...product];
                this.setState({ ...this.state, productsTransfer: newProductsTransfer });
                this.props.formInput(newProductsTransfer, "productsTransfer");
                
            }
        }

        if (this.props.bulkTransferScannedTime !== newProps.bulkTransferScannedTime && newProps.bulkTransferScannedTime != null && newProps.bulkTransferScannedTime != undefined) {
            if (newProps.bulkTransferScanProductData && newProps.bulkTransferScanProductData.length > 0) {
                this.addProductToTransfer(newProps.bulkTransferScanProductData[0]);
            } else {
                this.props.showBulkTransferUpdateSnackbar("Product not found");
            }
        }
    }

    getProductOptions = () => {
        return (this.props.productsWarehouses && this.props.productsWarehouses.list ? this.props.productsWarehouses.list : [] || []).map(item => {
            return {
                text: item.productName,
                value: item.productId,
                product: item
            };
        });
    }

    selectQty = (event, index, currentQtyValue) => {
        let list = [...this.state.productsTransfer];
        let item = { ...list[index] };
        item.QtyToTransfer = event.target.value.replace(/\D/g, "");
        item.QtyToTransfer = item.QtyToTransfer == "" || (parseInt(item.QtyToTransfer)) <= currentQtyValue ? item.QtyToTransfer : currentQtyValue
        list[index] = item
        this.setState({ ...this.state, productsTransfer: list })
    }

    selectPackageReference = (id, selectedItem) => {
        this.setState(prevState => {
            const { value = "", quantity = 0 } = selectedItem || {};
            const updatedProductsTransfer = prevState.productsTransfer.map(product => {
                if (product.productId === id) {
                    return {
                        ...product,
                        packageReferenceSelected: value || "",
                        CurrentQty: quantity
                    };
                }
                return product;
            });
            this.props.formInput(updatedProductsTransfer, "productsTransfer");
            return { productsTransfer: updatedProductsTransfer };
        });
    }

    selectCategoryPackageReference = (value, id, quantity) => {
        let index = this.props.productsByCategory.findIndex(object => {
            return object.productId == id;
        })
        let myObject = this.props.productsByCategory[index]
        myObject['categoryPackageReferenceSelectedQuantity'] = quantity;
        myObject['categoryPackageReferenceSelectedValue'] = value;
    };

    getBulkTransfersById(id) {
        this.props.getBulkTransfersById(id);
    }

    addProductFromBulkTransfer = (bulkTransfer) => {
        let modelList = []
        bulkTransfer.bulkTransferProducts.forEach(element => {
            let model = {
                productId: element.productId,
                ProductName: element.productName,
                SKU: element.productSKU,
                PackageReference: element.packageReference,
                packageReferenceSelected: element.packageReference || "",
                QtyToTransfer: element.quantityTransfered,
                CurrentQty: element.currentQty,
                Cost: element.cost
            }

            if (this.state.productsTransfer.length == 0) {
                modelList.push(model);
            }
        });
        this.setState({ ...this.state, productsTransfer: [...this.state.productsTransfer, ...modelList], bulkTransfer });
    }

    addProductsToTransfer = (item) => {
        let productsPO = item.products;
        let arrayModel = []
        productsPO.forEach(element => {
            let productFound = this.state.productsTransfer.filter(x => x.productId == element.productId);
            let model = {
                productId: element.productId,
                ProductName: element.product,
                SKU: element.sku,
                PackageReference: element.packageReference,
                packageReferenceSelected: element.packageReference || "",
                QtyToTransfer: 0
            }
            if (productFound.length == 0) {
                arrayModel.push(model)
            }
        });
        if (arrayModel.length === 0) {
            this.props.showBulkTransferUpdateSnackbar("These PO products have been added already.");
            this.setState({ ...this.state, showDialogPO: false })
        } else {
            const productsTransfer = this.state.productsTransfer.concat(arrayModel);
            this.setState({ ...this.state, productsTransfer, selectedPOOpen: false, showDialogPO: false }, () => {
                arrayModel.forEach((element) => {
                    this.props.getProductQuantity({
                        productId: element.productId,
                        warehouseId: this.state.bulkTransfer.fromWarehouseId,
                        packageReference: element.PackageReference
                    })
                })
            })
            
        }
    }

    addOneProductToTransfer = (item) => {
        let arrayModel = []
        let model = {
            productId: item.productId,
            ProductName: item.productName,
            SKU: item.productSKU,
            PackageReference: item.warehouse.packageReference,
            packageReferenceSelected: item.warehouse.packageReference,
            CurrentQty: item.warehouse.quantity,
            QtyToTransfer: 0
        }
        if (model.productId != null || model.productId != '') {
            arrayModel.push(model);
        }

        if (arrayModel.length == 0) {
            this.props.showBulkTransferUpdateSnackbar("These products have been added already.");
            this.setState({ ...this.state, showDialogPO: false });
            this.setState({ ...this.state, showDialogCat: false });
        } else {
            // Assuming arrayModel and productsTransfer are arrays of objects with a unique identifier, such as productId.
            let uniqueProductIds = new Set(this.state.productsTransfer.map(c => ({
                productId: c.productId,
                packageReference: c.packageReferenceSelected
            })));

            let uniqueProductIdsArray = Array.from(uniqueProductIds);

            // Filter the arrayModel to include only the elements that are not in productsTransfer.
            let newProducts = arrayModel.filter(element => {
                return !uniqueProductIdsArray.some(objTransfer =>
                    objTransfer.productId === element.productId &&
                    objTransfer.packageReference === element.PackageReference
                );
            });

            let productsTransfer = this.state.productsTransfer.concat(newProducts);
            this.setState({ ...this.state, productsTransfer, selectedPOOpen: false, showDialogCat: true }, () => {
                arrayModel.forEach((element) => {
                    this.props.getProductQuantity({
                        productId: element.productId,
                        warehouseId: this.state.bulkTransfer.fromWarehouseId,
                        packageReference: element.PackageReference
                    })
                })
            });
        }
    }

    addProductToTransfer = (product) => {
        let productFound = this.state.productsTransfer.filter(x => x.productId == product.productId);
        let selectedPackageReference = product.warehouses;
        if (productFound.length === 0) {
            if (product.warehouses.length == 1) {
                this.props.getProductQuantity({
                    productId: product.productId,
                    warehouseId: this.state.bulkTransfer.fromWarehouseId,
                    packageReference: product.warehouses[0].packageReference
                });
                selectedPackageReference = product.warehouses[0].packageReference;
            }
            selectedPackageReference = product.warehouses[0].packageReference ;
            let qty = product.warehouses[0].quantity;
            let model = {
                productId: product.productId,
                ProductName: product.productName,
                SKU: product.productSKU,
                PackageReference: product.warehouses,
                packageReferenceSelected: selectedPackageReference,
                CurrentQty: qty,
                QtyToTransfer: 0
            };
            this.setState({ ...this.state, productsTransfer: [...this.state.productsTransfer, model] })
        }
        else {
            this.props.showBulkTransferUpdateSnackbar("This product has been added already.");
        }
    }

    addProductsExcelToTransfer = (productList, excelUploadProducts) => {
        let arrayModel = []
        productList.forEach(item => {
            let productFound = this.state.productsTransfer.filter(x => x.productId == item.productId);

            let selectedPackageReference = excelUploadProducts.filter(x => x.SKU == item.productSKU).length > 0 ? excelUploadProducts.filter(x => x.SKU == item.productSKU)[0].SelectedPackageReference : "";

            let matchedPackageReference = null;
            let currentQuantity = null;

            if (item.warehouses.length === 1) {
                matchedPackageReference = item.warehouses[0].packageReference;
                currentQuantity = item.warehouses[0].quantity;
            } else {
                const filterPackageReferences = item.warehouses.filter(x => x.packageReference === selectedPackageReference);
                if (filterPackageReferences.length > 0) {
                    matchedPackageReference = filterPackageReferences[0].packageReference;
                    currentQuantity = filterPackageReferences[0].quantity;
                }
            }

            const model = {
                productId: item.productId,
                ProductName: item.productName,
                SKU: item.productSKU,
                PackageReference: item.warehouses,
                packageReferenceSelected: matchedPackageReference,
                CurrentQty: currentQuantity,
                QtyToTransfer: 0
            }
            if (productFound.length == 0) {
                arrayModel.push(model);
            }
        });
        if (arrayModel.length == 0) {
            this.props.showBulkTransferUpdateSnackbar("These products have been added already.");
        } else {
            let productsTransfer = this.state.productsTransfer.concat(arrayModel);
            this.setState({ ...this.state, productsTransfer });
        }
    }

    sendBulkTransfer = () => {
        const noPkgRefChosen = this.state.productsTransfer.filter(x => x.packageReferenceSelected === null);

        if (noPkgRefChosen.length === 0) {
            const products = this.state.productsTransfer.map((item) => {
                const qty = item.QtyToTransfer * 1;
                console.log(item);
                const checkPackageReference = typeof item.packageReferenceSelected === "string" ? item.packageReferenceSelected : item.packageReferenceSelected.value
                return {
                    ProductId: item.productId,
                    PackageReference: checkPackageReference || item.packageReference || "",
                    Quantity: qty
                }
            })
            // console.log(products);
            const data = {
                id: this.state.bulkTransfer.id,
                fromBranch: this.state.bulkTransfer.fromWarehouseBranchId,
                fromWarehouse: this.state.bulkTransfer.fromWarehouseId,
                toBranch: this.state.bulkTransfer.toWarehouseBranchId,
                toWarehouse: this.state.bulkTransfer.toWarehouseId,
                title: this.state.bulkTransfer.title,
                needReceive: this.state.bulkTransfer.needReceive,
                productList: products
            }
            // console.log(data)
            this.props.sendBulkTransfer(data);
        } else {
            alert("Please ensure you have selected a package reference for all products.");
        }
    }

    handleKeyDown = (e) => {
        if (
            e.key === 'ArrowUp' ||
            e.key === 'ArrowDown' ||
            e.key === 'PageUp' ||
            e.key === 'PageDown' ||
            e.key === 'End' ||
            e.key === 'Home'
        ) {
            e.preventDefault();
        }
    }

    mapProductTransfer = (model) => {
        model.sort((a, b) => {
            if (a.ProductName < b.ProductName)
                return -1;
            if (a.ProductName > b.ProductName)
                return 1;
            return 0;
        });
        return model.map((item, indexModel) => {
            const isArrayPackageReference = Array.isArray(item.PackageReference);
            let packageReference = () => { };
            let currentQtyValue = item.CurrentQty;
            
            if (isArrayPackageReference) {
                let packageReferenceList = item.PackageReference.filter((item) =>
                    item.warehouseId === this.state.bulkTransfer.fromWarehouseId
                ).map((pr, index) => {
                    return {
                            text: pr.packageReference === "" ? "No lot number" : pr.packageReference,
                            value: pr.packageReference,
                            quantity: pr.quantity,
                            id: index
                        }
                });

                if (packageReferenceList.length > 1) {
                    packageReference = () => {
                        if (item.PackageReference) {
                            return (
                                <div style={{ marginLeft: 5, marginRight: 5, marginTop: 10 }}>
                                    <SelectInputPackageReference
                                        name={`${item.productId}PackageReference`}
                                        id={`${item.productId}`}
                                        label="Package Reference"
                                        options={packageReferenceList}
                                        hintText="Package Reference"
                                        onChange={(event) => {
                                            const selectedOption = packageReferenceList.find(pr => pr.value === event.target.value);
                                            this.selectPackageReference(item.productId, selectedOption);
                                        }}
                                        defaultValue={item.packageReferenceSelected}
                                    />
                                </div>
                            )
                        }
                    }
                } else {
                    packageReference = () => {
                        return !item.PackageReference[0].packageReference ? (<div>No lot number</div>) : (<div>{item.PackageReference[0].packageReference}</div>)
                    }
                }
                const currentPackageReference = packageReferenceList.find(pkg => pkg.value === item.packageReferenceSelected || pkg.value === this.props.formState[`${item.productId}PackageReference`])
                currentQtyValue = currentPackageReference.quantity || 0;
            } else {
                currentQtyValue = item.CurrentQty;
                packageReference = () => {
                    // replace all string and check if it's empty
                    return !item.PackageReference.replace(/ /g, '') ? (<div>No lot number</div>) : (<div>{item.PackageReference}</div>)
                }
            }

            const qtyInput = () => {
                return this.state.bulkTransfer.transferStatus == 1 ? (
                    <div style={{ marginLeft: 5, marginRight: 5 }}>
                      <TextField
                        type='number'
                        variant="standard"
                        name={`${item.productId}Qty`}
                        value={item.QtyToTransfer}
                        fullWidth={false}
                        hintText={"0"}
                        max={currentQtyValue}
                        onChange={event => { this.selectQty(event, indexModel , currentQtyValue) }}
                        onKeyDown={this.handleKeyDown}
                        onWheel={event => event.currentTarget.blur()}
                      />
                    </div>
                ) : (
                    <div style={{ marginLeft: 5, marginRight: 5 }}>
                        {item.QtyToTransfer}
                    </div>
                )
            }

            const showCost = () => {
                return <div style={{ marginLeft: 5, marginRight: 5 }}>
                    {getDollarFormat(item.Cost)}
                </div>
            }

            const removeTransfer = () => {
                return this.state.bulkTransfer.transferStatus == 1 && (
                    <div>
                        <Button
                            type="IconDeleteButton"
                            className="btn-space glyphicon-remove-circle"
                            onTouchTap={() => this.removeTransferProduct(indexModel)}
                        />
                    </div>)
            }

            const products = {
                productId: (<div>{item.productId}</div>),
                ProductName: (<div>{item.ProductName}</div>),
                SKU: (<div>{item.SKU}</div>),
                PackageReference: packageReference(),
                CurrentQty: (<div>{currentQtyValue}</div>),
                QtyToTransfer: qtyInput(),
                Cost: showCost(),
                DeleteTransfer: removeTransfer(),
            }

            return products;
        });
    }

    getPurchaseOrders = () => {
        const model = {
            id: +this.props.purchaseNumber || "",
            branchId: this.state.bulkTransfer.fromWarehouseBranchId || 0,
            description: "",
            paymentDueDate: this.props.date || null,
            dateExpected: this.props.dateExpected || null,
            createdDate: null,
            status: 3,
            total: null,
            orderBy: "DESC",
            sortBy: this.state.sortBy,
            page: this.state.activePage,
            itemsPerPage: 15
        }
        this.props.getPurchaseOrders(model);
    }
    
    changeProductPage = (e) => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, this.searchProducts);
    }

    search = () => {
        this.getPurchaseOrders();
    }

    searchProductByCategory = () => {
        this.setState({ activePage: 1 }, this.searchProducts);
    }

    selectAllProductsByCategory = () => {
        this.setState({ activePage: 1 }, this.addAllProductsToTransfer);
    }

    getProductFomPO = () => {
        this.setState({ ...this.state, showDialogPO: true })
    }

    getProductFomCat = () => {
        this.props.getCategories(this.state.bulkTransfer.fromWarehouseBranchId)
        this.setState({ ...this.state, showDialogCat: true })
    }

    searchProducts = () => {
        if (this.props.categoryIdSearch) {
            const model = {
                page: this.state.activePage,
                itemsPerPage: 15,
                categoryId: this.props.categoryIdSearch,
                branchId: this.state.bulkTransfer.fromWarehouseBranchId,
                warehouseId: this.state.bulkTransfer.fromWarehouseId
            };
            this.props.getProductsByCategory(model);
        }
        else {
            this.props.showError(
                <div>
                    <p>It is necessary to select one Category for search.</p>
                </div>
            )
        }
    }

    processAllProductCategoryLst() {
        if (Array.isArray(this.props.productsByCategory) && this.props.productsByCategory.length > 0) {
            let arrayModel = []
            this.props.productsByCategory.forEach(element => {
                const selectedQuantity = !element.categoryPackageReferenceSelectedValue ? element.warehouses[0].quantity : element.categoryPackageReferenceSelectedQuantity || 0;
                const selectedValue = !element.categoryPackageReferenceSelectedValue ? element.warehouses[0].packageReference : element.categoryPackageReferenceSelectedValue || "";
                const model = {
                    productId: element.productId,
                    ProductName: element.productName,
                    SKU: element.productSKU,
                    PackageReference: selectedValue,
                    packageReferenceSelected: selectedValue,
                    CurrentQty: selectedQuantity,
                    QtyToTransfer: 0
                }
                arrayModel.push(model);
            });
            if (arrayModel.length == 0) {
                this.props.showBulkTransferUpdateSnackbar("These products have been added already.");
                this.setState({ ...this.state, showDialogCat: false });
            } else {
                // Assuming arrayModel and productsTransfer are arrays of objects with a unique identifier, such as productId.
                let uniqueProductIds = new Set(this.state.productsTransfer.map(c => ({
                    productId: c.productId,
                    packageReference: c.packageReferenceSelected
                })));

                let uniqueProductIdsArray = Array.from(uniqueProductIds);

                // Filter the arrayModel to include only the elements that are not in productsTransfer.
                let newProducts = arrayModel.filter(element => {
                    return !uniqueProductIdsArray.some(objTransfer =>
                        objTransfer.productId === element.productId &&
                        objTransfer.packageReference === element.PackageReference
                    );
                });

                let productsTransfer = this.state.productsTransfer.concat(newProducts);
                this.setState({ ...this.state, productsTransfer, selectedPOOpen: false, showDialogCat: false }, () => {
                    arrayModel.forEach((element) => {
                        this.props.getProductQuantity({
                            productId: element.productId,
                            warehouseId: this.state.warehouseFrom,
                            packageReference: element.PackageReference
                        })
                    })
                });
            }
        }
    }

    addAllProductsToTransfer = () => {
        if (this.props.categoryIdSearch && this.props.productsByCategory.length > 0) {
            this.processAllProductCategoryLst();
        }
        else {
            this.props.showError(
                <div>
                    <p>There isn't any result in table!.</p>
                </div>
            )
        }
    }

    closeDialogTrasferFromPO = () => {
        this.setState({ ...this.state, showDialogPO: false })
    }

    closeDialogTrasferFromCategories = () => {
        this.setState({ ...this.state, showDialogCat: false });
    }

    closeDialogPODetails = () => {
        this.setState({ ...this.state, selectedPOOpen: false })
    }

    removeTransferProduct = (indexProduct) => {
        const trasnferList = this.state.productsTransfer.filter((item, index) => index != indexProduct);
        this.setState({ ...this.state, productsTransfer: trasnferList });
    }

    lookProductsToTransfer = (item) => {
        this.setState({ ...this.state, selectedPOOpen: true, dialogPOTitle: "PO #" + item.id, selectedPO: item })
    }

    downloadTemplate = () => {
        window.location.href = this.props.apiURL + `unauthorized/bulktransfertemplate`;
    }

    getStatus = (transferStatus) => {
        switch (transferStatus) {
            case 1:
                return "Pending"
            case 2:
                return "Completed"
            case 3:
                return "Need to Receive"
        }
    }

    downloadExcel = (bulkTransferId) => {
        this.props.getCsvReport(`warehouses/bulkTransfer/downloadexcel?bulkTransferId=${bulkTransferId}`, `bulkTransfer${bulkTransferId}`);
    }

    render() {
        let transferDialogColumns = [
            { key: "ProductName", label: "Product Name", width: '22%' },
            { key: "SKU", label: "SKU" },
            { key: "PackageReference", label: "Package Reference" },
            { key: "CurrentQty", label: "Current quantity" },
            { key: "QtyToTransfer", label: "Quantity to transfer" }
        ];

        let productsSearchByCategoriesColumns = [
            { key: "ProductName", label: "Product Name" },
            { key: "SKU", label: "SKU" },
            { key: "PackageReference", label: "PackageReference" },
            { key: "Quantity", label: "Quantity" },
            { key: "Icons", label: "", visibleMode: "d-none-xs" }
        ];

        if (this.state.bulkTransfer.transferStatus == 1) {
            transferDialogColumns.push({ key: "DeleteTransfer", label: "" });
        } else {
            transferDialogColumns.push({ key: "Cost", label: "Cost" });
        }

        const p = this.props;

        let categories = (p.categoriesList || []).map(c => ({
            text: c.name,
            value: c.id.toString()
        }));

        const listPurchaseOrders = (p.purchaseOrders || []).map((item) => {
            const total = item.total || 0;

            return {
                ID: item.id,
                Description: item.description,
                Total: this.props.userRole !== 'SalesLead' ? `$ ${total.toFixed(2)}` : 'N.A.',
                Qty: item.products.length,
                View: (<Button
                    key={2}
                    name="IconViewButton"
                    label="View"
                    primary={true}
                    onTouchTap={() => this.lookProductsToTransfer(item)} />),
                Icons: (<Button
                    key={2}
                    name="buttonRemoveItem"
                    label="Add"
                    primary={true}
                    onTouchTap={() => this.addProductsToTransfer(item)} />),
                Status: item.status
            };
        });

        const productAddList = (p.productsByCategory || []).flatMap((obj) => {
            return obj.warehouses.filter((item) =>
                item.warehouseId == this.state.bulkTransfer.fromWarehouseId && item.quantity > 0
            ).map((item, index) => {
                let modeladded = {
                    productId: obj.productId,
                    productName: obj.productName,
                    warehouse: {
                        quantity: item.quantity,
                        packageReference: item.packageReference
                    }
                };

                return {
                    ProductName: obj.productName || '',
                    productId: obj.productId || '',
                    SKU: obj.productSKU || '',
                    PackageReference: item.packageReference === "" ? "No lot number" : item.packageReference,
                    Quantity: item.quantity || 0,
                    Icons: (
                        <Button
                            key={index}
                            name="buttonRemoveItem"
                            label="Add"
                            primary={true}
                            onTouchTap={() => this.addOneProductToTransfer(modeladded)}
                        />
                    ),
                };
            });
        });

        return (
            <Grid headerContent={this.state.bulkTransfer.transferStatus == 1 ? bulkTransferEditCrumb : bulkTransferViewCrumb}>
                {
                    this.state.bulkTransfer != "" && this.props.bulkTransfer != undefined ? (
                        <React.Fragment>
                            <PageHeaderWithButton title={`Bulk Transfer #${this.state.bulkTransfer.id}`}>
                            {
                                        this.state.bulkTransfer.transferStatus == 1 && (
                                            <Button
                                                type="SaveButton"
                                                className="ml-1"
                                                label="SAVE"
                                                style={{ float: 'right' }}
                                                secondary={true}
                                                onTouchTap={() => this.sendBulkTransfer()}
                                            />
                                        )
                                    }
                                    <Button
                                        type="DownloadButton"
                                        label="Download CSV"
                                        style={{ float: 'right' }}
                                        secondary={true}
                                        onTouchTap={() => this.downloadExcel(this.state.bulkTransfer.id)}
                                    />
                            </PageHeaderWithButton>
                            <CardSimple>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td className="text-left fw_bold">Title</td>
                                            <td className="text-left">{this.state.bulkTransfer.title}</td>
                                        </tr>
                                        <tr>
                                            <td className="text-left fw_bold">From</td>
                                            <td className="text-left">{this.state.bulkTransfer.fromWarehouseBranchName + " - " + this.state.bulkTransfer.fromWarehouseName}</td>
                                        </tr>
                                        <tr>
                                            <td className="text-left fw_bold">To:</td>
                                            <td className="text-left">
                                                {this.state.bulkTransfer.needReceive ?
                                                    this.state.bulkTransfer.toWarehouseBranchName + " - " + this.state.bulkTransfer.toWarehouseName + " ( On hold in Storage)" :
                                                    this.state.bulkTransfer.toWarehouseBranchName + " - " + this.state.bulkTransfer.toWarehouseName}</td>
                                        </tr>
                                        <tr>
                                            <td className="text-left fw_bold">Created Date:</td>
                                            <td className="text-left">{new Date(this.state.bulkTransfer.createdDate).toISOString().slice(0, 10)}</td>
                                        </tr>
                                        <tr>
                                            <td className="text-left fw_bold">Total Cost:</td>
                                            <td className="text-left">{getDollarFormat(this.state.bulkTransfer.totalCost)}</td>
                                        </tr>
                                        <tr>
                                            <td className="text-left fw_bold">Status:</td>
                                            <td className="text-left">{this.getStatus(this.state.bulkTransfer.transferStatus)}</td>
                                        </tr>
                                        {
                                            this.state.bulkTransfer.transferStatus == 2 ? (
                                                <tr>
                                                    <td className="text-left fw_bold">Completed Date :</td>
                                                    <td className="text-left">{new Date(this.state.bulkTransfer.modifiedDate).toISOString().slice(0, 10)}</td>
                                                </tr>
                                            ) : ("")
                                        }
                                    </tbody>
                                </table>
                            </CardSimple>
                        </React.Fragment>
                    ) : ("")
                }
            
                {
                    this.state.bulkTransfer.transferStatus == 1 && (
                        <div className="row">
                            <div className="col-lg-12 col-xs-6 d-flex p-0 align-items-center">
                                <Button
                                    type="SearchButton"
                                    className="btn-space mb-2"
                                    label="IMPORT product from PO"
                                    secondary={true}
                                    onTouchTap={() => this.getProductFomPO()}
                                />
                                <Button
                                    type="SearchButton"
                                    className="btn-space float-left mb-2"
                                    style={{ margin: "3px 5px" }}
                                    label="IMPORT product from Category"
                                    secondary={true}
                                    onTouchTap={() => this.getProductFomCat()}
                                />
                                <ExcelUploadBulkTransfer
                                    addProductsExcelToTransfer={this.addProductsExcelToTransfer}
                                    warehouseId={this.state.bulkTransfer.fromWarehouseId}
                                />
                                <Button
                                    mini={true}
                                    primary
                                    label="Download Template"
                                    className="bg-gray-Purple-p POListBtn btnNewBrandPOS mb-2"
                                    onTouchTap={this.downloadTemplate}
                                />
                            </div>
                            <div className="col-lg-12">
                                <AutoCompleteBulkTransfer
                                    minLength={3}
                                    name={`SearchProductId`}
                                    label="Search an existing product"
                                    hintText={"Product"}
                                    options={this.getProductOptions()}
                                    addProductToTransfer={this.addProductToTransfer}
                                    warehouseId={this.state.bulkTransfer ? this.state.bulkTransfer.fromWarehouseId : 0}
                                />
                            </div>
                        </div>
                    )
                }
                {
                    this.state.bulkTransfer && this.state.bulkTransfer.bulkTransferProducts ? (
                        <GenericTable
                            compName="bulkTransferTableEdit"
                            columns={transferDialogColumns}
                            rows={this.mapProductTransfer(this.state.productsTransfer)}
                            stripedRows={true}
                        />
                    ) : ("")
                }
             
                <DialogInput
                    title={<DialogHeaderWithClose text="Transfer from PO" classicClass="posDialogClassic" handleClose={() => this.closeDialogTrasferFromPO()} />}
                    modal={true}
                    autoScrollBodyContent={true}
                    open={this.state.showDialogPO}
                >
                    <div className="bg-light-opacity pb-2">
                        <SearchPOFilterBulkTrasfer
                            pageName={"dialogBulkTrasfer"}
                            cleanSearch={this.cleanSearch}
                            search={this.search}
                        />
                    </div>
                    <div className="list-table">
                        <GenericTable
                            compName="PO"
                            className="table_center"
                            tableHeaderClassName="table-pos"
                            tableBodyClassName="table-pos"
                            multiSelectable={false}
                            enableSelectAll={false}
                            displaySelectAll={false}
                            adjustForCheckbox={false}
                            displayRowCheckbox={false}
                            stripedRows={true}
                            columns={LOOKUP.purchaseOrder.tableColumnsDialogTransfer}
                            rows={listPurchaseOrders || []}
                        />
                        <Pagination
                            length={p.purchaseOrdersLenght || 0}
                            itemsPerPage={15}
                            activePage={this.state.activePage}
                            onPageChange={(e) => this.changePage(e)}
                            maxButtons={4} />
                    </div>
                </DialogInput>
                <DialogInput
                    title={<DialogHeaderWithClose text="Transfer from Categories" classicClass="posDialogClassic" handleClose={() => this.closeDialogTrasferFromCategories()} />}
                    actions={[
                        <Button
                            key={1}
                            type="CancelButton"
                            name="buttonCancelRemoveItem"
                            className="btn-space"
                            label={LOOKUP.common.cancel.text}
                            onTouchTap={() => this.closeDialogTrasferFromCategories()} />
                    ]}
                    modal={true}
                    autoScrollBodyContent={true}
                    open={this.state.showDialogCat}
                >
                        <div className="bg-light-opacity mb-2">
                            <ProductCategoriesListBulkTrasfer
                                categoriesList={categories}
                                searchProductByCategory={this.searchProductByCategory}
                                selectAllProductsByCategory={this.selectAllProductsByCategory}
                            />
                        </div>
                        <div className="list-table mb-2">
                            <GenericTable
                                compName="PO"
                                className="table_center"
                                tableHeaderClassName="table-pos"
                                tableBodyClassName="table-pos"
                                multiSelectable={false}
                                enableSelectAll={false}
                                displaySelectAll={false}
                                adjustForCheckbox={false}
                                displayRowCheckbox={false}
                                columns={productsSearchByCategoriesColumns}
                                rows={productAddList || []}
                            />
                            <Pagination
                                length={p.productCategoryListLength || 0}
                                itemsPerPage={15}
                                activePage={this.state.activePage}
                                onPageChange={(e) => this.changeProductPage(e)}
                                maxButtons={4} />
                        </div>
                </DialogInput>
                <DialogInput
                    title={<DialogHeaderWithClose text={this.state.dialogPOTitle} classicClass="posDialogClassic" handleClose={() => this.closeDialogPODetails()} />}
                    actions={[
                        <Button
                            key={1}
                            type="CancelButton"
                            name="buttonCancelRemoveItem"
                            className="btn-space"
                            label={LOOKUP.common.cancel.text}
                            onTouchTap={() => this.closeDialogPODetails()} />]}
                    open={this.state.selectedPOOpen}>
                    <div style={{ marginTop: 10 }}>
                        <p>This PO contains the follow products:</p>
                        <br></br>
                        <div>
                            {
                                this.state.selectedPOOpen ? this.state.selectedPO.products.map((item) => {
                                    return <p>- {item.product}</p>;
                                }) : ""
                            }
                        </div>
                    </div>
                </DialogInput>
            </Grid>
        );
    }
}

function mapStateToProps(state, ownProps) {
    let allBranches = [];
    if (state.common.userBranches != null && state.common.userBranches.length > 1 && state.common.branchId != null) {
        for (let i = 0; i < state.common.userBranches.length; i++) {
            allBranches.push({
                text: state.common.userBranches[i].name,
                value: state.common.userBranches[i].id
            })
        }
    }
    return {
        formState: state.form,
        categoriesList: state.entity.categoriesList || [],
        categoryIdSearch: state.form["ProductCategoriesListBulkTrasferCategoryIdSearch"] ? parseInt(state.form["ProductCategoriesListBulkTrasferCategoryIdSearch"]) : null,
        apiURL: state.common.store.apiUrl,
        purchaseOrders: state.entity.purchaseOrderList,
        purchaseOrdersLenght: state.entity.purchaseOrderListLength,
        date: state.form.dialogBulkTrasferDueDateFilter ? new Date(state.form['dialogBulkTrasferDueDateFilter']) : null,
        dateExpected: state.form.dialogBulkTrasferDateExpectedFilter ? new Date(state.form['dialogBulkTrasferDateExpectedFilter']) : null,
        purchaseNumber: state.form.dialogBulkTrasferPoFilter,
        branchId: state.common.branchId,
        productsByCategory: state.entity.productsWarehouses.list || [],
        productCategoryListLength: state.entity.productsWarehouses.total,
        allBranches: allBranches,
        product: state.entity.productForAdjustment,
        bulkTransferList: state.entity.bulkTransferList,
        bulkTransferSuccess: state.entity.bulkTransferSuccess,
        bulkTransfer: state.entity.bulkTransfer,
        productsWarehouses: state.entity.productsWarehouses,
        POSelected: state.form["POSelectedRows"],
        productQuantity: state.entity.productQuantity,
        bulkTransferScanProductData: state.entity.bulkTransferScanProductData,
        bulkTransferScannedTime: state.entity.bulkTransferScannedTime
    };
}

function mapDispatchToProps(dispatch) {
    return {
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        formError: (name, error) => dispatch(formError(name, error)),
        formInput: (name, value) => dispatch(formInput(value, name)),
        showError: (message) => dispatch(showError(message)),
        getBulkTransfersById: (id) => dispatch(getBulkTransfersById(id)),
        getProductQuantity: (model) => dispatch(getProductQuantity(model)),
        getPurchaseOrders: (model) => dispatch(getPurchaseOrderForBulkTransfer(model)),
        sendBulkTransfer: (model) => dispatch(sendBulkTransfer(model)),
        showBulkTransferUpdateSnackbar: (message) => dispatch({ type: types.SNACKBAR_SHOW_MESSAGE, message: message }),
        getProductsAutocompleteFromWarehouse: (model) => dispatch(getProductsAutocompleteFromWarehouse(model)),
        getCsvReport: (url, name) => dispatch(getCsvReport(url, name)),
        getCategories: (model) => dispatch(getCategories(model)),
        getProductsByCategory: (model) => dispatch(getProductsGroupedFromWarehouse(model))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(bulkTransferEdit));
